import type { StyleRule } from '@archipro-design/aria';
import {
    buttonClassName,
    labelClassName,
    pxToRem,
} from '@archipro-design/aria';
import { svgIconClassName } from '@fluentui/react-northstar';
import type { Property } from 'csstype';

export interface ManageDropdownDesign {
    trigger?: {
        marginRight?: Property.MarginRight;
        padding?: Property.Padding;
        paddingRight?: Property.PaddingRight;
    };
}
export interface ManageDropdownStyleProps {
    design?: ManageDropdownDesign;
}
export const PermissionContainer: StyleRule<ManageDropdownStyleProps> = ({
    design,
}) => ({
    alignSelf: 'flex-end',
    height: '100%',
    top: pxToRem(3),
    overflow: 'visible',
    [`& > .${buttonClassName}`]: {
        paddingRight: design?.trigger?.paddingRight ?? pxToRem(4),
    },
    [`& > .${buttonClassName} .${labelClassName}`]: {
        fontSize: pxToRem(16),
    },
});

export const CollapsedDropDownButton: StyleRule<ManageDropdownStyleProps> = ({
    design,
}) => ({
    [`& > .${labelClassName}`]: {
        display: 'flex',
        justifyContent: 'space-between',
        ...(design?.trigger?.padding && { padding: design?.trigger?.padding }),
        [`& > .${svgIconClassName}`]: {
            marginLeft: pxToRem(6),
            marginRight: pxToRem(2.5),
            marginTop: pxToRem(4),
            height: pxToRem(9),
            width: pxToRem(10),
        },
    },
});

export const SelectPermissions: StyleRule = ({ theme }) => ({
    [`& > .${buttonClassName}`]: {
        display: 'block',
        width: '100%',
        zIndex: theme.siteVariables.zIndexes.menuItem,

        [`& > .${labelClassName}`]: {
            minWidth: pxToRem(106),

            display: 'flex',
            justifyContent: 'space-between',
            [`& > .${svgIconClassName}`]: {
                marginLeft: pxToRem(6.5),
            },
        },
    },
    boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.16)',
});
